import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
import { client } from '../../../utils/apolloClient'

const initialState = {
  ApiIntegrationsDetails:[],
  isApiIntegrationsDetailsPending: true,
  isDepartmentsPending: true,
  isConnectionsAGPending: true,
  departments: [],
  connectionsAGs: [],
  errorInFetchingDepartments: false,
  errorInFetchingConnectionsAGs: false
};


export const getApiIntegrationsDetails = createAsyncThunk(
  'getApiIntegrationsDetails',
  async ({payload, token, params}) => {
    const queryString = params ? `?${params.join('&')}` : '';
    return client.authorizeRequest({
      method: 'POST',
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/connections/entities${queryString}`,
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
);

export const getDepartments = createAsyncThunk(
  'getDepartments',
  async ({entityIds, token}) => {
    return client.authorizeRequest({
      method: 'GET',
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/departments?entityIds=${entityIds}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
);

export const getConnectionsAndAccessGrants = createAsyncThunk(
  'getConnectionsAndAccessGrants',
  async ({payload, token}) => {
    return client.authorizeRequest({
      method: 'POST',
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/bulkSubscriptions/connections`,
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
);


export const apiIntegrationsSlice = createSlice({
  name: 'apiIntegrationsSlice',
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: {
    [getApiIntegrationsDetails.fulfilled]: (state, action) => {
      state.isApiIntegrationsDetailsPending = false;
      state.ApiIntegrationsDetails = action.payload && action.payload.data;
    },
    [getApiIntegrationsDetails.pending]: state => {
      state.isApiIntegrationsDetailsPending = true;
    },
    [getApiIntegrationsDetails.rejected]: state => {
      state.isApiIntegrationsDetailsPending = false;
    },
    [getDepartments.fulfilled]: (state, action) => {
      state.isDepartmentsPending = false;
      state.departments = action.payload.data;
      state.errorInFetchingDepartments = false;
    },
    [getDepartments.pending]: state => {
      state.isDepartmentsPending = true;
      state.errorInFetchingDepartments = false;
    },
    [getDepartments.rejected]: state => {
      state.isDepartmentsPending = false;
      state.errorInFetchingDepartments = true;
    },
    [getConnectionsAndAccessGrants.fulfilled]: (state, action) => {
      state.isConnectionsAGPending = false;
      state.connectionsAGs = action.payload.data;
      state.errorInFetchingConnectionsAGs = false;
    },
    [getConnectionsAndAccessGrants.pending]: state => {
      state.isConnectionsAGPending = true;
      state.errorInFetchingConnectionsAGs = false;
    },
    [getConnectionsAndAccessGrants.rejected]: state => {
      state.isConnectionsAGPending = false;
      state.errorInFetchingConnectionsAGs = true;
    }
  }
});

export const {
  resetState,
} = apiIntegrationsSlice.actions;

export default apiIntegrationsSlice.reducer;
